import React from 'react'

export const FeaturedIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className="mr-1"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.002 21.534C17.52 21.534 22 17.054 22 11.536C22 6.018 17.52 1.539 12.002 1.539C6.485 1.539 2.005 6.018 2.005 11.536C2.005 17.054 6.485 21.534 12.002 21.534ZM12.002 20.034C7.312 20.034 3.505 16.226 3.505 11.536C3.505 6.846 7.312 3.039 12.002 3.039C16.692 3.039 20.5 6.846 20.5 11.536C20.5 16.226 16.692 20.034 12.002 20.034ZM12.002 13.534C11.588 13.534 11.252 13.198 11.252 12.784V7.284C11.252 6.87 11.588 6.534 12.002 6.534C12.416 6.534 12.752 6.87 12.752 7.284V12.784C12.752 13.198 12.416 13.534 12.002 13.534ZM12 16.534C12.552 16.534 13 16.086 13 15.534C13 14.982 12.552 14.534 12 14.534C11.448 14.534 11 14.982 11 15.534C11 16.086 11.448 16.534 12 16.534Z" fill="#1C6094" />
  </svg>
)
